import { render, staticRenderFns } from "./SearchTypeIcon.vue?vue&type=template&id=54cfc9fb&scoped=true&"
import script from "./SearchTypeIcon.vue?vue&type=script&lang=js&"
export * from "./SearchTypeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cfc9fb",
  null
  
)

export default component.exports